<script>
import displaySettings from "@/mixin/displaySettings";
import { SmartLink } from '@/shared/ui/link';
import { BlueButton } from '@/shared/ui/form';
import FileInputMultiple from "@/components/app/quotation/components/FileInput.vue";
import ChatFilePreviewModal from "@/components/app/quotation/components/ChatFilePreviewModal.vue";
import { ClipIcon, DownloadIcon, TelegramIcon, CheckIcon, FileIcon } from '@/shared/ui/icons';
import { getQuotationMessages, sendQuotationMessages, readQuotationMessages  } from "@/api/quotation";

export default {
  name: "QuotationChat",
  components: { SmartLink, BlueButton, FileInputMultiple, ClipIcon, DownloadIcon, TelegramIcon, CheckIcon, FileIcon, ChatFilePreviewModal },
  props: ['dialogVisible', 'quotationId', 'quotationData'],
  mixins: [displaySettings],
  data() {
    return {
      existingFiles: {},
      chatFiles: null,
      previewFiles: [],
      fileCaption: '',
      newMessage: null,
      messages: [],
      lastMessageId: null,
      pollInterval: null
    };
  },
  computed: {
    isSendBtnActive() {
      return this.newMessage || this.chatFiles
    }
  },
  watch: {
    messages: {
      handler() {
        this.scrollToBottom();
      },
      deep: true,
    }
  },
  async mounted() {
    if (this.quotationId) {
      await this.loadMessages();
    }
    this.scrollToBottom();
  },
  methods: {
    handleFilesSelected(files) {
      this.previewFiles = files;
      this.fileCaption = this.newMessage;
      this.newMessage = '';
      this.$refs.previewModal.show();
    },
    handleSendFiles({ files, caption }) {
      this.sendMessage(files, caption);
      this.previewFiles = [];
      this.fileCaption = '';
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.chatRoll;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    shortFileName(fileName) {
      const name = fileName;
      const maxLength = 25;
      if (name.length <= maxLength) return name;
      const extension = name.split('.').pop();
      const baseName = name.substring(0, maxLength - extension.length - 3);

      return `${baseName}...${extension}`;
    },
    isManagerMessage(msg) {
      return msg.sender_type_id === 2;
    },
    isSelfMessage(msg) {
      return msg.sender_type_id === 1;
    },
    async loadMessages() {
      const { data } = await getQuotationMessages(this.quotationId);
      this.messages = data;
      this.lastMessageId = data.length ? data[data.length - 1].id : null;
      await this.markAsRead();
    },
    async fetchNewMessages() {
      if (!this.lastMessageId) return;

      const { data } = await axios.get(`/api/quotation-requests/${this.quotationId}/messages`, {
        params: {
          last_id: this.lastMessageId
        }
      });

      if (data.length) {
        this.messages.push(...data)
        this.lastMessageId = data[data.length - 1].id

        await this.markAsRead();
      }
    },
    async markAsRead() {
      const params = {
        quotation_request_id: this.id
      }
      await readQuotationMessages(this.quotationId, params)
    },
    async sendMessage(files, caption) {
      const formData = new FormData();
      formData.append('quotation_request_id', this.quotationId);
      formData.append('message', caption ?? this.newMessage ?? '');

      if (files && Array.isArray(files)) { // this.chatFiles
        files.forEach(file => {
          formData.append(`files[]`, file, file.name);
        });
      } else if (files instanceof File) { // this.chatFiles
        formData.append(`files[]`, files, files.name); // this.chatFiles
      }

      const sendResponse = await sendQuotationMessages(this.quotationId, formData);

      if (sendResponse.status && sendResponse.data?.id) {
        this.newMessage = null;
        this.chatFiles = null;
        this.messages.push(sendResponse.data);
        this.lastMessageId = sendResponse.data.id;
        //this.$refs.uploadChat.clearFiles();
       // await this.fetchNewMessages();
      }
    },
  }
}
</script>

<template>
  <div class="chat">
    <div class="chat-wrap">
      <div ref="chatRoll" class="chat-messages">
        <div v-if="messages.length" v-for="msg in messages" :key="msg.id" :class="['message-item', {'align-right' : isSelfMessage(msg) }]">
          <div :class="['message-wrap', isManagerMessage(msg) ? 'their' : 'self']">
            <div class="message-content">
              <div class="message-word">{{ msg.message }}</div>
              <div class="message-files" v-for="fileItem in msg.files">
                <template v-if="['image/png', 'image/jpeg', 'image/webp', 'image/gif'].includes(fileItem.mime_type)">
                  <a :href="'/storage/' + fileItem.path" target="_blank" :download="fileItem.name || 'file'">
                    <img :src="'/storage/' + fileItem.path" class="chat-img" alt="image" />
                  </a>
                </template>

                <template v-else>
                  <a :href="'/storage/' + fileItem.path" :download="fileItem.original_name || 'file'" class="file-download-link">
                    <div class="file-name-icon">
                      <ClipIcon :color="'#09090B'" />
                    </div>
                    <div class="mt-1 file-name-span">{{ shortFileName(fileItem.original_name) }}</div>
                  </a>
                </template>
            </div>
            </div>
            <div class="message-date">
              <div class="message-read-status">
                <CheckIcon :color="'#000'" />
                <CheckIcon v-if="msg.reads.length" class="readed-icon" :color="'#000'" /><!-- isManagerMessage(msg) &&  -->
              </div>
              <div class="message-createdAt">
                {{ msg.createdAt }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chat-input-wrapper">
        <div class="chat-input-block chat-input-block-fixed">

          <file-input-multiple @files-selected-for-preview="handleFilesSelected">
            <template #button>
              <div class="upload-link upload-link-trigger">
                <ClipIcon class="date-input__icon" :color="'#6B7280'" />
              </div>
            </template>
          </file-input-multiple>
<!-- old -->
<!--          <file-input-multiple ref="uploadChat" v-model="chatFiles" :title="'Прикріпити техпаспорт'">-->
<!--            <template #button>-->
<!--              <div class="upload-link">-->
<!--                <ClipIcon class="date-input__icon" :color="'#6B7280'"/>-->
<!--              </div>-->
<!--            </template>-->
<!--          </file-input-multiple>-->

          <textarea class="send-textarea send-textarea-fixed" v-model="newMessage"></textarea>
          <button class="btn chat-btn-send chat-btn-send-fixed" @click="sendMessage" :disabled="!isSendBtnActive">
            <TelegramIcon class="send-chat-icon" :color="'#6B7280'"/>
          </button>
        </div>
      </div>
    </div>


    <ChatFilePreviewModal
      ref="previewModal"
      :files="previewFiles"
      v-model="fileCaption"
      @files-updated="updatedPreviewFiles => previewFiles = updatedPreviewFiles"
      @send-files="handleSendFiles"
    />

    <!--                    <input type="file" @change="handleFile" />-->
    <!--                    <file-input-->
    <!--                      v-model="chatFiles"-->
    <!--                      :full-width="false"-->
    <!--                      @input="replaceFile($event, chatFiles)"-->
    <!--                    >-->
    <!--                      <template #button>-->
    <!--                        <div class="upload-link">-->
    <!--                          <ClipIcon-->
    <!--                            class="date-input__icon"-->
    <!--                            :color="'#1976d2'"-->
    <!--                          />-->
    <!--                          <span> Додати файл</span>-->
    <!--                        </div>-->
    <!--                      </template>-->
    <!--                    </file-input>-->

  </div>
</template>

<style lang="scss">
.chat {
  width: 100%;
}
.chat-wrap {
  padding: 10px;
  height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url("/images/chat-background-3.jpg"); background-size: 100% 100%, contain;
  background-repeat: no-repeat, no-repeat;
  background-position: top center;
}
.chat-messages {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  scrollbar-width: thin;
}
.message-item {
  width: 100%;
  display: flex;
  &.align-right {
    justify-content: flex-end;
  }
  .message-wrap {
    padding: 4px 6px 3px 6px;
  }
  .self {
    width: 100%;
    max-width: 80%;
    margin-top: 3px;
    border: solid 1px #E5E7EB;
    border-radius: 7px;
    background-color: #fff;
  }
  .their {width: 100%;
    max-width: 80%;
    margin-top: 3px;
    border: solid 1px #E5E7EB;
    border-radius: 7px;
    background-color: #F1EFEF;
  }
  .message-word {
    font-size: 14px;
    word-break: break-all;
  }
  .message-files {
    margin-top: 4px;
  }
  .file-download-link {
    display: flex;
  }
  .file-name-icon {
    font-weight: bold;
  }
  .file-name-span {
    margin-left: 3px;
    font-weight: bold;
  }
  .message-date {
    display: flex;
    justify-content: flex-end;
    .message-read-status {
      .readed-icon {
        margin-left: -8px;
      }
    }
    .message-createdAt {
      font-size: 12px;
      margin-left: 5px;
    }
  }
  img {
    width: 100px;
    height: 100px;
  }
}

.chat-input-block {
  width: 100%;
  padding: 3px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border: solid 1px #d5d5d5;
  background-color: #ffffff;
  border-radius: 7px;

  .chat-btn-send {
    border-radius: 7px;
  }
  .upload-link {
    padding: 9px 0px;
    border-radius: 50px;
    svg {
      width: 35px;
    }
    &:hover {
      background-color: #d5d5d5;
    }
  }

  .send-textarea {
    width: 75%;
  }

  .send-chat-icon path {
    fill: #6B7280;
  }
}
</style>
